export const AppUrl = {
    signin: 'signin',
    verify: 'verify',
    list_room: 'list-room',
    checkin: 'checkin',
    customer_info: 'customer-info',
    bookign_info: 'bookign-info',
    booking_success: 'booking-success',
    payment: 'payment',
    upload_payment: 'upload-payment',
    guest_room: 'guest-room',
    room_quantity: 'room-quantity',
    list_location: 'list-location',
    profile: 'profile',
}